import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('saloon', {
  cherry: 'whiskey_bottle',
  lemon: 'playing_cards',
  orange: 'poker_chips',
  bell: 'saloon_bell',
  star: 'piano_wild',
  seven: 'saloon_doors',
  gem: 'ruby_brooch',
  scatter: 'horseshoe_scatter',
  money: 'saloon_safe',
});

/** Saloon — GENERATED by scaffoldSlot from
 *  content/slots/saloon.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const SALOON_THEME: Theme = {
  id: 'saloon',
  name: 'Saloon',
  palette: {
    accent: 0xb5532e,
    secondary: 0xd99a5a,
    warm: 0xf2d27a,
    frameFill: 0x2a160f,
    bgGradientTop: 0x4a2818,
    bgGradientBottom: 0x190b07,
    dimOverlay: 0x0c0604,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Sarsaparilla', glyph: '🥤', tint: 0xc88a3a, weight: 5, textureAlias: 'saloon:cherry',
        winVideoAlias: 'saloon:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Cards', glyph: '🃏', tint: 0xd8d0c0, weight: 5, textureAlias: 'saloon:lemon',
        winVideoAlias: 'saloon:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Poker Chips', glyph: '🔴', tint: 0xc0392b, weight: 4, textureAlias: 'saloon:orange',
        winVideoAlias: 'saloon:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Bar Bell', glyph: '🔔', tint: 0xd0a84e, weight: 3, textureAlias: 'saloon:bell',
        winVideoAlias: 'saloon:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Saloon Piano', glyph: '🎹', tint: 0xb5532e, weight: 2, textureAlias: 'saloon:star',
        winVideoAlias: 'saloon:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Saloon', glyph: '🚪', tint: 0x8a5a3a, weight: 2, textureAlias: 'saloon:seven',
        winVideoAlias: 'saloon:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Ruby', glyph: '💎', tint: 0xc0392b, weight: 2.5, textureAlias: 'saloon:gem',
        winVideoAlias: 'saloon:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Horseshoe', glyph: '🧲', tint: 0xb0b0b0, weight: 0.5, textureAlias: 'saloon:scatter',
        winVideoAlias: 'saloon:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Saloon Safe', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'saloon:money',
        winVideoAlias: 'saloon:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x2a160f, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xb5532e, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x2a160f, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xd99a5a, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xb5532e, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x2a160f, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xb5532e, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xf2d27a, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'saloon:bg', path: 'environment/saloon.png' },
      columnBackground: { alias: 'saloon:column_bg', path: 'reel/saloon_column_bg.png' },
      border: { alias: 'saloon:border', path: 'brand/border_frontier.png' },
    },
  },
};
